module.exports = __webpack_public_path__ + "img/join us.9a75dd63.png";